const EnviosDevoluciones = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 space-y-4">
      <h1 className="text-2xl font-black uppercase italic">Envíos y Devoluciones</h1>

      <p>
        SANAN realiza envíos principalmente en España, pudiendo realizar envíos internacionales bajo solicitud.
      </p>

      <p>
        Los plazos de entrega son aproximados y pueden variar según el destino.
      </p>

      <p>
        El cliente dispone de 14 días naturales desde la recepción del pedido para solicitar una devolución.
      </p>

      <p>
        El producto debe devolverse en perfecto estado y sin uso.
      </p>

      <p>
        Salvo error o defecto del producto, los gastos de devolución correrán a cargo del cliente.
      </p>
    </div>
  );
};

export default EnviosDevoluciones;

